module.exports = __webpack_public_path__ + "static/media/about-header-image1.8bb16b03.png";